export enum PersonnelOperation {
    EVENT_MANAGE = 'operation.entity.personnel.event-manage'
}
